import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { translate } from './Translate';
import Icon from './Icon';
import { KeyboardEvents } from '../utils/accessibility/KeyboardEvents';
import { KEYBOARD_KEYS } from '../constants';
import { AccessibilityStore, TranslationStore } from '../stores';
import { Theme } from '../models/Theme';

const Button = styled<any, any>('button', 'button', 'watchListToggle')`
    ${propStyles};
    border: none;
    outline: none;
    cursor: pointer;
    transition: transform 160ms linear, color 160ms linear;
    transform: ${p =>
        p['data-selected'] ? 'rotate3d(0,1,0,180deg)' : 'rotate3d(0,1,0,0deg)'};
`;

Button.defaultProps = {
    fontSize: '1.6em',
    color: 'body',
    bgColor: 'transparent',
    selected: {
        color: 'primary',
    },
};

const StarIcon = styled<any, any>(Icon, 'starIcon', 'watchListToggle')``;

StarIcon.defaultProps = {
    height: '1em',
    width: '1em',
};

interface WatchListToggleProps {
    theme?: Theme;
    accessibilityStore?: AccessibilityStore;
    translationStore?: TranslationStore;
    active: boolean;
    onClick: (e) => void;
    accessibilityContext: string;
    metricContext: string;
    iconOnFileName?: string;
    iconOffFileName?: string;
}

@inject('accessibilityStore', 'translationStore')
@observer
class WatchListToggle extends Component<WatchListToggleProps> {
    keyboardEvents: KeyboardEvents<HTMLButtonElement>;

    constructor(props: WatchListToggleProps) {
        super(props);
        this.initializeKeyboardEvents();
    }

    initializeKeyboardEvents() {
        this.keyboardEvents = new KeyboardEvents({
            name: 'WatchListToggle',
            debug: false,
            defaults: {
                accept: {
                    down: {
                        preventDefault: true,
                        stopPropagation: true,
                    },
                },
            },
        });

        this.keyboardEvents.bindEventToMany(
            [
                { type: 'key', direction: 'down', key: KEYBOARD_KEYS.ENTER },
                { type: 'key', direction: 'down', key: KEYBOARD_KEYS.SPACE },
                { type: 'key', direction: 'down', key: KEYBOARD_KEYS.SPACEBAR },
            ],
            event => {
                this.props.onClick(event);
            }
        );
    }

    render() {
        const {
            theme,
            translationStore,
            active,
            onClick,
            accessibilityContext,
            metricContext,
            iconOnFileName = 'WatchlistToggleIcon',
            iconOffFileName = 'WatchlistToggleOutlineIcon',
            accessibilityStore,
            ...props
        } = this.props;

        return (
            <Button
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'WatchlistToggleButton'
                )}
                title={
                    active
                        ? translate(translationStore, 'Remove from Watch List')
                        : translate(translationStore, 'Add to Watch List')
                }
                onClick={onClick}
                data-selected={active}
                data-metric-id={`watchlist-toggle-${metricContext}`}
                {...props}
                {...this.keyboardEvents.onKeyProps}
                {...theme.WatchListToggle}
            >
                {active ? (
                    <StarIcon
                        fileName={iconOnFileName}
                        accessibilityContext={accessibilityContext}
                    />
                ) : (
                    <StarIcon
                        fileName={iconOffFileName}
                        accessibilityContext={accessibilityContext}
                    />
                )}
            </Button>
        );
    }
}
export default withTheme(WatchListToggle) as any;



// WEBPACK FOOTER //
// ./src/Components/WatchListToggle.tsx